export default __webpack_public_path__ + "static/media/Group 1565.db7c1195.svg";